import {defineStore} from "pinia";
// Trick to include JSDOC typedefs from the other file
import * as Types from '@/services/message.service';

/**
 * @typedef Settings
 * @property {Types.AdvancedSearch} filters
 * @property {Sort} ordering
 * @property {string[]} hiddenColumns
 */

/**
 * @typedef Sort
 * @property {string} field
 * @property {('asc' | 'desc')} sortOrder
 */

const VIEW_SETTINGS_KEY = 'AM_MSG_VIEW_SETTINGS';
const VIEW_MODE_KEY = 'AM_MSG_VIEW_MODE';

const useSettingsStore = defineStore('settings', {
  state: () => ({
    title: "",
    subtitle: "",
    viewMsgMode: (!window.isMobile && localStorage.getItem(VIEW_MODE_KEY) !== null) ? localStorage.getItem(VIEW_MODE_KEY) : 'list',
    viewSettings: JSON.parse(localStorage.getItem(VIEW_SETTINGS_KEY)) ?? {}
  }),
  getters: {
    getViewSettings(state) {
      return (view = 'default') => {
        if (!state.viewSettings[view]) {
          state.viewSettings[view] = getDefaultViewSettings(view);
        }

        return state.viewSettings[view];
      }
    }
  },
  actions: {
    setTitle(value) {
      this.title = value
    },
    setSubtitle(value) {
      this.subtitle = value
    },
    setViewMsgMode(value) {
      this.viewMsgMode = value

      localStorage.setItem(VIEW_MODE_KEY, value)
    },
    saveViewSettings() {
      localStorage.setItem(VIEW_SETTINGS_KEY, JSON.stringify(this.viewSettings));
    },
    clearViewSettings(view = 'default') {
      this.setViewSettings(getDefaultViewSettings(view), view);
    },
    clearAllViewsSettings() {
      localStorage.removeItem(VIEW_SETTINGS_KEY);
    },
    clearViewFilters(view) {
      /** @type {Settings}*/
      let viewSettings = this.getViewSettings(view);
      let cleanFilters = getDefaultViewSettings().filters;
      viewSettings.filters = cleanFilters;
      this.saveViewSettings();
    }
  }
});

/**
 * @param {string} viewName
 * @returns {Settings}
 */
export function getDefaultViewSettings(viewName) {
  let hiddenColumns = [];

  if (viewName) {
    let columnsByFolder = {
      [Types.FOLDERS.INBOX]   : ['to'],
      [Types.FOLDERS.SENT]    : ['from'],
      [Types.FOLDERS.RECEIPTS]: ['to'],
      [Types.FOLDERS.DRAFTS]  : ['from'],
    }

    let folder = viewName.split('-').at(-1);
    if (columnsByFolder[folder] != null) {
      hiddenColumns = hiddenColumns.concat(columnsByFolder[folder]);
    }
  }

  return {
    filters: {
      from: null,
      to: null,
      subject: null,
      dateFrom: null,
      dateTo: null,
      seen: null,
      tags: null,
      withoutTags: null,
      status: null,
      withoutStatus: null,
      users: null,
      notAssigned: null,
      retained: null
    },
    ordering: {
      field: 'date',
      sortOrder: 'desc'
    },
    hiddenColumns
  };
}

export default useSettingsStore
